import { useAppDispatch, useAppSelector } from 'app/hooks';
import { seedDuctedDesignConfiguration } from 'features/configurations';
import { useEffect } from 'react';
import {
  selectDuctedDesignConfigurationIds,
  selectDuctedDesignRequired
} from 'utils/ducted-design';
import { collectDuctedLayoutSpaces } from 'utils/ducted-layout-configuration';
import { isSystemDesignStageTab } from 'utils/system-design-stage-tabs';

type DuctedDesignConfigurationWatcherProps = {
  loading: boolean;
};

export default function DuctedDesignConfigurationWatcher({
  loading
}: DuctedDesignConfigurationWatcherProps) {
  const dispatch = useAppDispatch();
  const designRequired = useAppSelector(selectDuctedDesignRequired);
  const hasDesign = useAppSelector(
    (state) => selectDuctedDesignConfigurationIds(state).size > 0
  );
  const layoutSpaceCount = useAppSelector(
    (state) => collectDuctedLayoutSpaces(state.structure.structure).length
  );
  const onDesignStageTab = useAppSelector((state) =>
    isSystemDesignStageTab(state.ui.activeTab)
  );

  useEffect(() => {
    if (
      loading ||
      !onDesignStageTab ||
      !designRequired ||
      hasDesign ||
      layoutSpaceCount === 0
    ) {
      return;
    }
    dispatch(seedDuctedDesignConfiguration());
  }, [
    loading,
    onDesignStageTab,
    designRequired,
    hasDesign,
    layoutSpaceCount,
    dispatch
  ]);

  return null;
}
